interface BadgeProps {
  badgeClass: string;
  icon?: string;
  children: React.ReactNode;
}

export default function Badge({ badgeClass, icon, children }: BadgeProps) {
  return (
    <span className={badgeClass}>
      {icon && <i className={`${icon} text-[11px]`}></i>}
      {children}
    </span>
  );
}
